import {
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Pagination({
  page,
  setPage,
  totalPages,
  totalItems,
  pageSize,
}) {
  if (totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="mt-16 flex flex-col items-center gap-4 md:flex-row md:justify-between px-0 md:px-8 lg:px-24">

      {/* Showing Results */}
      <p className="text-sm tracking-wide text-cottage-primary">
        Showing{" "}
        <span className="font-semibold text-cottage-primary">
          {start}-{end}
        </span>{" "}
        of{" "}
        <span className="font-semibold text-cottage-primary">
          {totalItems}
        </span>{" "}
        properties
      </p>

      {/* Controls */}
      <div className="flex items-center gap-6">

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="flex items-center gap-2 rounded-xl border border-slate-200 px-5 py-3 transition hover:bg-cottage-primary hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          <FontAwesomeIcon icon={faAngleLeft} />
          Previous
        </button>

        <span className="text-sm uppercase tracking-[0.2em] text-cottage-primary text-center">
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="flex items-center gap-2 rounded-xl border border-slate-200 px-5 py-3 transition hover:bg-cottage-primary hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          Next
          <FontAwesomeIcon icon={faAngleRight} />
        </button>

      </div>
    </div>
  );
}